import { render } from "./ProfileOrganizations.vue?vue&type=template&id=3f0fe9e8&scoped=true"
import script from "./ProfileOrganizations.vue?vue&type=script&lang=js"
export * from "./ProfileOrganizations.vue?vue&type=script&lang=js"

import "./ProfileOrganizations.vue?vue&type=style&index=0&id=3f0fe9e8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0fe9e8"]])

export default __exports__